<list-view *ngIf="listeOd" [liste]="listeOd" [popinList]="true"></list-view>
